import { create } from 'zustand';

// Lets a route restrict which scene objects get added to the THREE scene when a document loads,
// e.g. so /checklist-item/:id can show only the one item being viewed instead of every item in
// the document. Populated by SceneObjectScopeComponent and read by SceneDocumentManager.addToScene.
type SceneObjectScopeState = {
    // null = unrestricted, i.e. add every scene object (current/default behavior for routes that
    // don't render SceneObjectScopeComponent). An empty Set is a deliberate "show nothing" state,
    // distinct from null - used e.g. while /checklist-item/add hides all pre-existing items.
    scopedSceneObjectUuids: ReadonlySet<string> | null;
    setScopedSceneObjectUuids: (uuids: ReadonlySet<string> | null) => void;
    // Resets to unrestricted; call on unmount so leaving a scoped route never leaks the
    // restriction into a route that doesn't opt in.
    clearScope: () => void;
};

export const useSceneObjectScopeStore = create<SceneObjectScopeState>((set) => ({
    scopedSceneObjectUuids: null,
    setScopedSceneObjectUuids: (uuids) => set({ scopedSceneObjectUuids: uuids }),
    clearScope: () => set({ scopedSceneObjectUuids: null }),
}));
